(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.hdt-subcollections-swipe').forEach((section) => {
    const viewport = section.querySelector('.hdt-slider__viewport');
    if (!viewport) return;

    const dismissHint = () => {
      section.classList.add('hdt-swipe-hint-dismissed');
      viewport.removeEventListener('scroll', dismissHint);
      viewport.removeEventListener('pointerdown', dismissHint);
      viewport.removeEventListener('touchstart', dismissHint);
    };

    viewport.addEventListener('scroll', dismissHint, { passive: true });
    viewport.addEventListener('pointerdown', dismissHint, { passive: true });
    viewport.addEventListener('touchstart', dismissHint, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('hdt-delivery-assurance')) {
    customElements.define('hdt-delivery-assurance', class extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.positioned) {
          const formId = this.dataset.targetForm;
          const form = document.getElementById(formId) || document.querySelector(`form[id="${CSS.escape(formId)}"]`);

          if (form) {
            const buttonArea = form.closest('hdt-buy-buttons, [data-buy-buttons], .hdt-product-form, .hdt-product-form__buttons') || form;
            buttonArea.insertAdjacentElement('afterend', this);
            this.dataset.positioned = 'true';
          }
        }

        this.hidden = false;
        this.updateDeliveryWindow();
      }

      updateDeliveryWindow() {
        const output = this.querySelector('[data-delivery-window]');
        if (!output) return;

        const addWorkingDays = (date, days) => {
          const result = new Date(date);
          let added = 0;
          while (added < days) {
            result.setDate(result.getDate() + 1);
            if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
          }
          return result;
        };

        const format = new Intl.DateTimeFormat(undefined, { day: 'numeric', month: 'short' });
        const start = addWorkingDays(new Date(), Number(this.dataset.minDays || 1));
        const end = addWorkingDays(new Date(), Number(this.dataset.maxDays || 4));
        output.textContent = `${format.format(start)}–${format.format(end)}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
